import { apiClient } from './client';

export interface MdmRecognitionStatusDto {
  recognitionStatusId: number;
  recognitionStatusName: string;
  recognitionStatusDesc?: string;
  displayOrder: number;
  isActive: boolean;
  backgroundColor: string;
  textColor: string;
}

export const recognitionStatusApi = {
  list(): Promise<MdmRecognitionStatusDto[]> {
    return apiClient.get<{ items: MdmRecognitionStatusDto[] }>('/api/recognition-statuses').then(r => r.items || []);
  },
};
